import { useCallback } from "react";
import { useAuth } from "@/auth/useAuth";

export type OnboardingKey =
  | "chat"
  | "pratiche_list"
  | "dashboard"
  | "clienti_list"
  | "dettaglio_pratica"
  | "dettaglio_cliente"
  | "dettaglio_bolletta"
  | "profilo_staff";

interface UseOnboardingResult {
  /** Versione del tour già vista da questo utente. 0 = mai visto. */
  seenVersion: number;
  markSeen: (version: number) => Promise<void>;
}

/**
 * Il flag salvato è la **versione** del tour vista, non un booleano: alzare la
 * version di un tour lo fa ripartire una volta sola, solo per quel tour, anche
 * per chi l'aveva già chiuso.
 *
 * Retrocompatibilità senza migrazione: i flag scritti prima del 2026-09-12 sono
 * booleani, e `Number(true) === 1` / `Number(false) === 0` li colloca da soli
 * alla versione giusta.
 */
export function useOnboarding(key: OnboardingKey): UseOnboardingResult {
  const { user, setOnboardingFlag } = useAuth();
  const seenVersion = Number(user?.onboarding_flags?.[key] ?? 0);

  const markSeen = useCallback(
    async (version: number) => {
      try {
        await setOnboardingFlag(key, version);
      } catch (err) {
        console.error("Failed to mark onboarding seen:", err);
      }
    },
    [key, setOnboardingFlag],
  );

  return { seenVersion, markSeen };
}
